/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EditClaimReservationRequest
 */
export interface EditClaimReservationRequest {
    /**
     * 
     * @type {string}
     * @memberof EditClaimReservationRequest
     */
    editedByAgentName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EditClaimReservationRequest
     */
    numberOfTickets?: number;
    /**
     * 
     * @type {string}
     * @memberof EditClaimReservationRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditClaimReservationRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditClaimReservationRequest
     */
    notes?: string | null;
    /**
     * Optional new encoded timeslot. Only provided when date/time is being changed.
     * This value comes from the timeslot availability call and internally encodes location, date, time, and duration.
     * @type {string}
     * @memberof EditClaimReservationRequest
     */
    timeslotId?: string | null;
}

/**
 * Check if a given object implements the EditClaimReservationRequest interface.
 */
export function instanceOfEditClaimReservationRequest(value: object): value is EditClaimReservationRequest {
    return true;
}

export function EditClaimReservationRequestFromJSON(json: any): EditClaimReservationRequest {
    return EditClaimReservationRequestFromJSONTyped(json, false);
}

export function EditClaimReservationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditClaimReservationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'editedByAgentName': json['editedByAgentName'] == null ? undefined : json['editedByAgentName'],
        'numberOfTickets': json['numberOfTickets'] == null ? undefined : json['numberOfTickets'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'timeslotId': json['timeslotId'] == null ? undefined : json['timeslotId'],
    };
}

export function EditClaimReservationRequestToJSON(value?: EditClaimReservationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'editedByAgentName': value['editedByAgentName'],
        'numberOfTickets': value['numberOfTickets'],
        'email': value['email'],
        'phone': value['phone'],
        'notes': value['notes'],
        'timeslotId': value['timeslotId'],
    };
}

